import { render, staticRenderFns } from "./VxCellPermissionsCheckbox.vue?vue&type=template&id=120c7fe6&"
import script from "./VxCellPermissionsCheckbox.vue?vue&type=script&lang=js&"
export * from "./VxCellPermissionsCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports